import produce from "immer";
import { CartState } from "../";

export interface SetDeliveryModeAction {
  mode: "express" | "normal";
  option: "home" | "mondialRelay";
  type: "setDeliveryMode";
}

export const setDeliveryMode = (state: CartState, action: SetDeliveryModeAction): CartState => {
  return produce(state, (draftState) => {
    const cartOption = draftState.cart.shippingOptions[action.option];
    if (!cartOption) {
      return;
    }
    cartOption.express.selected = action.mode === "express";
    cartOption.normal.selected = action.mode === "normal";
  });
};
